import { Controller } from "@hotwired/stimulus"

// Keeps the builder page from being restored in a stale state. Turbo Drive
// snapshots a page when you navigate away and reuses that snapshot on return —
// which would otherwise bring back the injected result modal (auto-reopening it)
// and whatever numbers you had typed. On turbo:before-cache we strip the modal,
// clear any leftover Bootstrap backdrop, and reset the form to the server's
// freshly-rendered defaults, so reopening any account starts fresh.
export default class extends Controller {
  static targets = ["form", "modal"]

  connect() {
    this.reset = this.reset.bind(this)
    document.addEventListener("turbo:before-cache", this.reset)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset)
  }

  reset() {
    if (this.hasModalTarget) this.modalTarget.innerHTML = ""
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
    if (this.hasFormTarget) this.formTarget.reset()
  }
}
